import { Component, EventEmitter, OnDestroy, OnInit, Output, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { TodoListItemService } from './todo-list-item.service';
import { FormBuilder, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { ToastrService } from 'ngx-toastr';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { HardCodedValues } from 'app/shared/common/hard-coded-values';
import { DatePipe } from '@angular/common';
import { SocketService } from 'app/shared/common/helper/socket.service';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { MatDialog, MatSidenav } from '@angular/material';
import { GetReportingToService } from 'app/shared/common/helper/get-reporting-to';
import { SelectItem } from 'primeng/primeng';
import { DateServiceService } from 'app/shared/common/helper/dateservice';
import { Configuration } from 'app/app.configuration';
import { DataService } from 'app/shared/common/helper/http-service';

import { RichTextEditorComponent } from '@syncfusion/ej2-angular-richtexteditor';
import { createElement } from '@syncfusion/ej2-base';
import * as CodeMirror from 'codemirror';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/css/css.js';
import 'codemirror/mode/htmlmixed/htmlmixed.js';
import { ScrumboardCardDialogComponent } from '../../scrumboard/board/dialogs/card/card.component';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ScrumboardService } from '../../scrumboard/scrumboard.service';
import { ActivityCenterService } from 'app/shared/common/helper/activity-center';

@Component({
  selector: 'app-todo-list-item',
  templateUrl: './todo-list-item.component2.html',
  styleUrls: ['./todo-list-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class TodoListItemComponent implements OnInit, OnDestroy {

  filters = [
    {
      'id': 0,
      'handle': 'starred',
      'title': 'Starred',
      'icon': 'star'
    },
    {
      'id': 1,
      'handle': 'important',
      'title': 'Important',
      'icon': 'error'
    },
    {
      'id': 2,
      'handle': 'assigned',
      'title': 'Assigned Task',
      'icon': 'alarm_on'
    },
    {
      'id': 3,
      'handle': 'created task',
      'title': 'Created Task',
      'icon': 'today'
    },
    {
      'id': 4,
      'handle': 'expired task',
      'title': 'Expired Task',
      'icon': 'update'
    }
  ];

  tags = [
    {
      'id': 1,
      'handle': 'proposal',
      'title': 'Proposal',
      'color': '#388E3C'
    },
    {
      'id': 2,
      'handle': 'sales',
      'title': 'Sales',
      'color': '#F44336'
    },
    {
      'id': 3,
      'handle': 'documentation',
      'title': 'Documentation',
      'color': '#FF9800'
    },
    {
      'id': 4,
      'handle': 'hiring',
      'title': 'Hiring',
      'color': '#0091EA'
    },
    {
      'id': 5,
      'handle': 'project management',
      'title': 'Project Management',
      'color': 'pink'
    }
  ];

  filtersAndTags = [
    {
      name: "All",
      data: [
        {
          'id': 0,
          'handle': 'all',
          'title': 'All',
          'icon': 'star'
        }
      ]
    },
    {
      name: "Filters",
      data: [
        {
          'id': 0,
          'handle': 'starred',
          'title': 'Starred',
          'icon': 'star'
        },
        {
          'id': 1,
          'handle': 'important',
          'title': 'Important',
          'icon': 'error'
        },
        {
          'id': 2,
          'handle': 'assigned',
          'title': 'Assigned Task',
          'icon': 'alarm_on'
        },
        {
          'id': 3,
          'handle': 'created task',
          'title': 'Created Task',
          'icon': 'today'
        },
        {
          'id': 4,
          'handle': 'expired task',
          'title': 'Expired Task',
          'icon': 'update'
        }
      ]
    },
    {
      name: "Tags",
      data: [
        {
          'id': 1,
          'handle': 'proposal',
          'title': 'Proposal',
          'color': '#388E3C'
        },
        {
          'id': 2,
          'handle': 'sales',
          'title': 'Sales',
          'color': '#F44336'
        },
        {
          'id': 3,
          'handle': 'documentation',
          'title': 'Documentation',
          'color': '#FF9800'
        },
        {
          'id': 4,
          'handle': 'hiring',
          'title': 'Hiring',
          'color': '#0091EA'
        },
        {
          'id': 5,
          'handle': 'project management',
          'title': 'Project Management',
          'color': 'pink'
        }
      ]
    }
  ];

  currentDay = this.datePipe.transform(new Date(), 'EEEE');
  taskType: Array<string> = ["Does not repeat", "Daily", 'Weekdays', `Weekly on ${this.currentDay}`, `Monthly on the third ${this.currentDay}`, "Every weekday (Monday to Friday)", "Custom..."];
  statusList = [];
  todoCols = [
    { field: 'position', header: 'Position' },
    { field: 'title', header: 'Title' },
    // { field: 'tag', header: 'Tag' },
    { field: 'owner', header: 'Owner' },
    { field: 'assignees', header: 'Assignees' },
    { field: 'department', header: 'Department' },
    { field: 'dueDate', header: 'Due date' },
    { field: 'status', header: 'Status' },
  ];
  thingsToDo: any;
  projectId: any;
  done: any;
  inprogressList: any;
  todoForm: FormGroup;
  organizerImage = '';
  organizerName = '';
  empRole = '';
  profileId = '';
  firstName = '';
  lastName = '';
  todoType = '';
  filteredOption = '';
  filterType = '';
  tagType = '';
  labelList = [];
  deptOptions: SelectItem[];
  reportingToOptions1: SelectItem[];
  reportingToOptions2: SelectItem[];
  ownerOptions: SelectItem[];
  starred = false;
  important = false;
  completed = false;
  deleted = false;
  todoId = '';
  thingsToDoCount = 0;
  doneCount = 0;
  inprogressCount = 0;
  filterCondition = [];
  tagCondition = [];
  status = '';
  reportingList = [];
  reportingToDD = [];
  reportingToOptions: SelectItem[];
  loading: boolean;
  submitted = false;
  previousComments = [];
  organizerEmail = '';
  isDefaultProject = true;
  @ViewChild('drawer', { static: false }) drawer: MatSidenav;
  currentDate = new Date();
  @ViewChild('regForm', { static: false }) regForm: NgForm;
  @ViewChild(FormGroupDirective, { static: false }) formGroupDirective: FormGroupDirective;
  @ViewChild('actualTimeConfirm', { static: false }) actualTimeConfirm: TemplateRef<any>;
  @ViewChild('previousInProgressTask', { static: false }) previousInProgressTask: TemplateRef<any>;
  @ViewChild('customTask', { static: false }) customTask: TemplateRef<any>;

  statusDropdown;
  actualTimeForTask;
  desktopLoginStatus;
  public tools: object = {
    items: ['Undo', 'Redo', '|',
      'Bold', 'Italic', 'Underline', 'StrikeThrough', '|',
      'FontName', 'FontSize', 'FontColor', 'BackgroundColor', '|',
      'SubScript', 'SuperScript', '|',
      'LowerCase', 'UpperCase', '|',
      'Formats', 'Alignments', '|', 'OrderedList', 'UnorderedList', '|',
      'Indent', 'Outdent', '|', 'CreateLink',
      'Image', '|', 'ClearFormat', 'Print', 'SourceCode', '|']
  };
  public quickTools: object = {
    image: [
      'Replace', 'Align', 'Caption', 'Remove', 'InsertLink', '-', 'Display', 'AltText', 'Dimension']
  };
  @ViewChild('toolsRTE', { static: false }) public rteObj: RichTextEditorComponent;
  public maxLength: number = 2000;
  public textArea: HTMLElement;
  public myCodeMirror: any;

  todoSearchUser = '';
  todoSelectReporting = '';
  todoSelectAssignee = '';
  todoSelectDepartment = '';
  todoSelectedStatus = '';
  inprogressSearchUser = '';
  inprogressSelectReporting = '';
  inprogressSelectAssignee = '';
  inprogressSelectDepartment = '';
  doneSearchUser = '';
  doneSelectReporting = '';
  doneSelectAssignee = '';
  doneSelectDepartment = '';
  @ViewChild('todoTable', { static: false }) private todoTable: any;
  @ViewChild('inprogressTable', { static: false }) private inprogressTable: any;
  @ViewChild('doneTable', { static: false }) private doneTable: any;
  todoNumber = '';
  tenantId: any;
  projects: any;
  dialogRef: any;
  selectedProjectName: any;
  selectedProjectId: any;
  viewProjectName: any;
  productsList = {};
  Object = Object;
  lastTwoWeeksTaskMetrics: any;
  unassignedProductsList = [];
  inProgress = [];
  unassignedProjectId: any;
  unassignedUserIds: any[];
  unassignedProfileIds: any[];
  canEnableTodoEstimatedHrs: any;
  TaskSyncInterval: NodeJS.Timeout;
  tenantDepartment: any;
  backlogBoardListId: any;
  getBacklogsSprintId: any;
  currentUser: any;
  selectedState = { name: 'new' };
  selectedTask: any;
  selectedStatusName: any;
  isTaskInprogress = false;
  isWebDesktop: boolean;
  inprogressTaskTime = 0;
  previousDayUserPlannedTasksId: any;
  isLoggedInWeb: boolean;
  isDrawerEditMode: boolean;
  dateEstimate;
  isSaved: boolean;
  scheduleType: string = 'Does not repeat';
  customDay: string = '';


  constructor(
    private todoListItemService: TodoListItemService,
    private formBuilder: FormBuilder,
    private parseService: ParseService,
    private toastr: ToastrService,
    private queryInterface: QueryInterface,
    private storageConfiguration: StorageConfiguration,
    private hardCodedValues: HardCodedValues,
    private _socket: SocketService,
    public dialog: MatDialog,
    private getReportingToService: GetReportingToService,
    private dateService: DateServiceService,
    private dataService: DataService,
    private configuration: Configuration,
    private router: Router,
    private spinner: NgxSpinnerService,
    private _scrumboardService: ScrumboardService,
    private activityCenterService: ActivityCenterService,
    private datePipe: DatePipe
  ) {
    (async () => {
      this.isWebDesktop = await this.isWebDesktopUsing(this.parseService.instance.User.current().get('profile').id);
    })();

    /**
    * * get inprogress task time from the header emit (toolbar component)
    */
    this.todoListItemService.inprogressTaskTime.subscribe((data: any) => {
      this.inprogressTaskTime = data;
    });

    /**
     * * call when the user timeSheet record created (started timeSheet in the web)
     */
    this.todoListItemService.timeSheetCreated.subscribe((data: any) => {
      if (data) {
        this.geTaskForProjectsBased();
      }
    });

    this.currentUser = this.parseService.instance.User.current();

    this.statusDropdown = [
      { name: 'new' },
      { name: 'backlog' },
      { name: 'in-progress' },
      { name: 'completed' }
    ];

    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    this.profileId = this.parseService.instance.User.current().get('profile').id;

    this.getTenantDepartment();
    // if (this.empRole !== 'Admin'){
    this.geTaskForProjectsBased();
    // }
    this.getDesktopStatus();
    if (this.isWebDesktop) { // ! show the inprogress task in header when using web as desktop app
      this.getInprogressTask();
    }
    // this.geTodoForProjectsBased();
    this.firstName = this.parseService.instance.User.current().get('firstName');
    this.lastName = this.parseService.instance.User.current().get('lastName');
    let currentDate = new Date();
    this.todoForm = this.formBuilder.group({
      title: ['', Validators.required],
      startDate: ['', Validators.required],
      dueDate: [''],
      notes: [''],
      estimatedHours: ['', Validators.required],
      completedHours: [0],
      department: [''],
      priority: [''],
      status: [''],
      starred: [false],
      important: [false],
      completed: [false],
      deleted: [false],
      tag: [''],
      commentsText: [''],
      assignees: [[], Validators.required],
      comments: [[]]
    });
  }

  async ngOnInit() {

    // this.isWebDesktop =  this.parseService.instance.User.current().get('profile').get('isWebDesktop') ? true : false;
    // this.isWebDesktop = await this.isWebDesktopUsing(this.parseService.instance.User.current().get('profile').id);
    await this.checkedLoginWeb(); // check logged in web today
    this.getOwner();
    this.getDepartment();
    this.getLabels();
    await this.getProjects();
    this.getAssignees();
    // this.getAssigneesForUnassignedProject();
    // if (this.empRole !== 'Admin'){
    this.TaskSyncInterval = setInterval(() => {
      this.geTaskForProjectsBased();
      this.toastr.success('Task Synced');
    }, 300000);
    // }
  }

  newTodo() {
    this.todoForm.reset();
    this.todoListItemService.clearSelectedTask();
    this.todoForm.patchValue({
      status: 'new',
      starred: false,
      important: false,
      completed: false,
      deleted: false,
      startDate: new Date(),
      estimatedHours: '01:00',
      tag: '',
      commentsText: '',
      comments: []
    });

    this.todoType = 'new';
    this.status = '';
    let image = '';
    let currentUserProfileImage = this.parseService.instance.User.current().get('profile').get('profileImageInfo');
    if (this.isEmpty(currentUserProfileImage)) {
      image = this.hardCodedValues.defaultProfileImg;
    } else {
      image = currentUserProfileImage.url
    }
    this.organizerImage = image;
    this.organizerName = this.firstName + ' ' + this.lastName;
  }

  isEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key))
        return false;
    }
    return true;
  }

  addComment(value) {
    let commentValue = this.todoForm.value.comments ? this.todoForm.value.comments : [];
    if (value.trim() !== '') {
      let fName = this.parseService.instance.User.current().get('profile').get('firstName');
      let lName = this.parseService.instance.User.current().get('profile').get('lastName');
      let userName = fName + ' ' + lName;
      commentValue.unshift({
        name: userName,
        comment: value,
        date: Date.now()
      });
      this.todoForm.patchValue({
        comments: commentValue,
      });
    }
    else {
      this.toastr.warning('Please add comments');
    }
  }

  async getToDoList(tasks, skip) {
    let eventArray = []
    let classArray = [];
    let i = skip;
    let department = '';
    for (const element of tasks) {
      let assignees = [];
      let assigneesId = [];

      const getRelationsAssignee = async function (result) {
        var reportingList = [];
        await result
          .query()
          .each(function (obj) {
            reportingList.push(obj);
          });
        return reportingList;
      }
      await getRelationsAssignee(element.get('assignee')).then(assignee => {
        for (const assigneeElement of assignee) {
          assignees.push({
            id: assigneeElement.id,
            name: assigneeElement.get('firstName') + ' ' + assigneeElement.get('lastName'),
            image: assigneeElement.get('profileImageInfo').url == undefined ? this.hardCodedValues.defaultProfileImg : assigneeElement.get('profileImageInfo').url
          });
          assigneesId.push(assigneeElement.id);
        }
      });
      let ownerProfile = '';
      var myObj = element.get('owner').get('profile').get('profileImageInfo');
      if (this.isEmpty(myObj)) {
        ownerProfile = this.hardCodedValues.defaultProfileImg;
      } else {
        ownerProfile = element.get('owner').get('profile').get('profileImageInfo').url
      }
      i = i + 1;
      let taskDetailsInfo = {
        position: i,
        id: element.id,
        title: element.get('title'),
        priority: element.get('priority'),
        department: element.get('department') ? element.get('department').id : '',
        departmentName: this.getReportingToService.getDepartmentDisplayName(element.attributes.department.attributes.name),
        estimatedHours: this.secondsToHms(element.get('estimatedHours')),
        notes: element.get('taskDetails').notes,
        startDate: element.get('startDate'),
        dueDate: element.get('dueDate'),
        taskExpired: (new Date().getTime() > new Date(element.get('dueDate') ? element.get('dueDate') : new Date).getTime()) ? true : false,
        completed: element.get('completed'),
        starred: element.get('starred'),
        important: element.get('important'),
        deleted: element.get('deleted'),
        createdAt: element.get('createdAt'),
        updatedAt: element.get('updatedAt').getTime(),
        owner: element.get('owner').id,
        assignees: assignees,
        assigneesId: assigneesId,
        tag: element.get('tag'),
        status: element.get('userPlannedStatus'),
        comments: element.get('comments'),
        ownerName: element.get('owner').get('profile').get('firstName') + ' ' + element.get('owner').get('profile').get('lastName'),
        ownerProfileImage: ownerProfile
      }
      classArray.push(taskDetailsInfo);
    }
    // eventArray = classArray.sort((a, b) => {
    //   if (a.dueDate > b.dueDate) { return -1; }
    //   if (a.dueDate < b.dueDate) { return 1; }
    // });
    eventArray = classArray;
    return eventArray;
  }

  async getThingsTodo(event?) {
    let condition = [];
    condition = [
      { condition: 'equalTo', field: 'deleted', value: false },
      // { condition: 'equalTo', field: 'completed', value: false },
      // { condition: 'equalTo', field: 'status', value: 'new' },
      { condition: 'include', value: 'owner' },
      { condition: 'include', value: 'owner.user' },
      { condition: 'include', value: 'department' },
      { condition: 'include', value: 'owner.user.profile' },
      { condition: 'descending', field: 'updatedAt' },
    ];
    if (this.empRole != 'Admin' && this.filterType != 'Created Task') {
      condition.push({ condition: 'containedIn', field: 'assigneesId', value: [this.profileId] });
    }
    const filter: any = event ? event.filters : '';
    if (!filter && filter != '') {
      if (this.filterCondition.length > 0) {
        condition.unshift(this.filterCondition[0]);
      }
      if (this.tagCondition.length > 0) {
        condition.unshift(this.tagCondition[0]);
      }
      const skip: number = event.first;
      this.thingsToDoCount = await this.getTotalRecordsCount(condition);
      this.lazyLoadThingsToDo(condition, skip, event.rows);
    } else {
      if (this.filterCondition.length > 0) {
        condition.unshift(this.filterCondition[0]);
      }
      if (this.tagCondition.length > 0) {
        condition.unshift(this.tagCondition[0]);
      }
      // tslint:disable-next-line:forin
      if (filter != '') {
        // tslint:disable-next-line:forin
        for (let key in filter) {
          let query = filter[key].value;
          key = key == 'bloodGroup' ? 'personalInfo.bloodGroup' : key;
          if (key == 'reportingTo' || key == 'owner' || key == 'assigneesId' || key == 'department' || key == 'personalInfo.bloodGroup' || key == 'status') {
            condition.push({ condition: 'containedIn', field: key, value: filter[key].value });
          } else {
            let filterValue = filter[key].value;
            if (key != 'officialInfo.officialEmail') {
              filterValue = filter[key].value.replace(/\b\w/g, l => l.toUpperCase());
            }
            condition.push({ condition: 'contains', field: key, value: filterValue });
          }
        }
      }
      this.thingsToDoCount = await this.getTotalRecordsCount(condition);
      let first = (event ? event.first : 0);
      let rows = (event ? event.rows : 10);
      if (this.thingsToDoCount < first) {
        first = 0;
      }
      this.lazyLoadThingsToDo(condition, first, rows);
    }
  }


  /**
   * * Get the last two weeks todo for users
   */
  geTodoForProjectsBased(): void {
    const startEndDatesByWeek = this.dateService.getLastTwoWeeks(new Date());
    const dateDifferent = this.dateService.startEndDateByDate(new Date());

    const lastThirtyDays = this.dateService.getLastThirtyDays(new Date());

    let condition = [];
    condition = [
      { condition: 'include', value: 'project' },
      { condition: 'equalTo', field: 'tenantId', value: this.tenantId },
      { condition: 'containedIn', field: 'assigneesId', value: [this.profileId] },
      { condition: 'greaterThan', field: 'createdAt', value: lastThirtyDays[0] },
      { condition: 'lessThan', field: 'createdAt', value: lastThirtyDays[1] },
      { condition: 'equalTo', field: 'isTodo', value: true }
    ];
    this.queryInterface.executeQuery(this.parseService, 'Tasks', condition).then(async results => {
      const totalTodo = JSON.parse(JSON.stringify(results.reverse()));
      for (const todo of totalTodo) {
        /**
        * * set the undefined userPlannedStatus field as new
        */
        if (todo.userPlannedStatus === undefined) {
          todo.userPlannedStatus = 'new';
        }
        let conditions = [];
        conditions = [
          { condition: 'equalTo', field: 'profileId', value: { __type: 'Pointer', className: 'Profile', objectId: this.profileId } },
          { condition: 'equalTo', field: 'taskId', value: { __type: 'Pointer', className: 'Tasks', objectId: todo.objectId } },
          { condition: 'include', value: 'profileId' },
          { condition: 'include', value: 'taskId' },
        ];
        this.queryInterface.executeQuery(this.parseService, 'UserPlannedTasks', conditions).then(async userPlannedTasksData => {
          let actualHours = 0;
          userPlannedTasksData = JSON.parse(JSON.stringify(userPlannedTasksData));
          if (userPlannedTasksData.length > 0) {
            userPlannedTasksData.forEach(plannedData => {
              actualHours += plannedData.actualHours;
            });
            todo.actualHoursTotal = actualHours;
            const isTaskInprogress = userPlannedTasksData.find((t) => t.status === 'in-progress');
            const isTaskCompleted = userPlannedTasksData.find((t) => t.status === 'completed');
            if (isTaskInprogress !== undefined) {
              todo.status = 'in-progress';
            } else if (isTaskCompleted !== undefined) {
              todo.status = 'completed';
            } else {
              todo.status = 'backlog';
            }
          }
          else {
            todo.actualHoursTotal = actualHours;
            todo.status = 'new';
          }
        });

      }
      // console.log('unassignedProductsList', totalTodo);
      this.unassignedProductsList = totalTodo;
      const totalTodoAndTask = [];

      for (const task of Object.keys(this.productsList)) {
        totalTodoAndTask.push(...this.productsList[task]);
      }
      totalTodoAndTask.push(...this.unassignedProductsList);

      // console.log('totalTodoAndTask', totalTodoAndTask);
      /**
       * * get the IN-PROGRESS data form the task and todo
       */
      const inProgress = totalTodoAndTask.find((task) => {
        return task.userPlannedStatus === 'in-progress';
      });
      this.inProgress = [];
      if (inProgress !== undefined) {
        this.inProgress.push(inProgress);
      }

      /**
       * * GroupBy the task by task-status Name
       * @groupBy function to group tasks by status
       */
      const taskGroupByStatus = this.groupBy(totalTodoAndTask, 'userPlannedStatus');


      /** 
       * * Calculate the task and hours for completed and backlogs card view
       */
      for (const K of Object.keys(taskGroupByStatus)) {
        const keyName = K;
        if (this.lastTwoWeeksTaskMetrics[K] !== undefined) {
          this.lastTwoWeeksTaskMetrics[K].task = taskGroupByStatus[K].length;
          taskGroupByStatus[K].forEach((task, Key, value) => {
            this.lastTwoWeeksTaskMetrics[keyName].hours += task.estimatedHours;
            if (keyName === 'completed') {
              // this.lastTwoWeeksTaskMetrics[keyName].actual += task.actualHoursTotal;
              this.lastTwoWeeksTaskMetrics[keyName].actual += task.completedHours;
            }
          });
        }
      }


      /**
       * * Calculate the task and hours for total hours
       */
      for (const K of Object.keys(this.lastTwoWeeksTaskMetrics)) {
        if (this.lastTwoWeeksTaskMetrics[K] !== 'total') {
          this.lastTwoWeeksTaskMetrics['total'].task += this.lastTwoWeeksTaskMetrics[K].task;
          this.lastTwoWeeksTaskMetrics['total'].hours += this.lastTwoWeeksTaskMetrics[K].hours;
        }
      }
      this.spinner.hide();
    });
  }


  geTaskForProjectsBased(): void {
    this.isWebDesktop = this.parseService.instance.User.current().get('profile').get('isWebDesktop') ? true : false;
    this.spinner.show();
    this.lastTwoWeeksTaskMetrics = {
      'total': { 'task': 0, 'hours': 0 },
      'completed': { 'task': 0, 'hours': 0, 'actual': 0 },
      'backlog': { 'task': 0, 'hours': 0 },
      'in-progress': { 'task': 0, 'hours': 0, 'actual': 0 },
      'new': { 'task': 0, 'hours': 0 },
    };
    const startEndDatesByWeek = this.dateService.getLastTwoWeeks(new Date());
    const dateDifferent = this.dateService.startEndDateByDate(new Date());
    let condition = [];
    condition = [
      { condition: 'include', value: 'Project' },
      { condition: 'equalTo', field: 'tenantId', value: this.tenantId },
      { condition: 'containedIn', field: 'assigneesId', value: [this.profileId] },
      { condition: 'greaterThan', field: 'createdAt', value: startEndDatesByWeek[0] },
      { condition: 'lessThan', field: 'createdAt', value: dateDifferent[1] },
      { condition: 'include', value: 'assignee' },
      { condition: 'notEqualTo', field: 'isTodo', value: true },
    ];
    this.queryInterface.executeQuery(this.parseService, 'Tasks', condition).then(async results => {
      const projectsLists = {};
      const totalTasks = JSON.parse(JSON.stringify(results.reverse()));
      totalTasks.forEach((task) => {
        // separate the task by project wise
        if (projectsLists[task.Project.projectInfo.projectName] !== undefined) {
          projectsLists[task.Project.projectInfo.projectName].push(task);
        }
        else {
          projectsLists[task.Project.projectInfo.projectName] = [];
          projectsLists[task.Project.projectInfo.projectName].push(task);
        }
      });
      for (const projectName of Object.keys(projectsLists)) {
        projectsLists[projectName].forEach(async task => {
          /**
           * * set the undefined userPlannedStatus field as new
           */
          if (task.userPlannedStatus === undefined) {
            // task.userPlannedStatus = 'completed';
            task.userPlannedStatus = 'new';
          }
          let conditions = [];
          conditions = [
            { condition: 'equalTo', field: 'profileId', value: { __type: 'Pointer', className: 'Profile', objectId: this.profileId } },
            { condition: 'equalTo', field: 'taskId', value: { __type: 'Pointer', className: 'Tasks', objectId: task.objectId } },
            { condition: 'include', value: 'profileId' },
            { condition: 'include', value: 'taskId' },
          ];
          await this.queryInterface.executeQuery(this.parseService, 'UserPlannedTasks', conditions).then(async userPlannedTasksData => {
            let actualHours = 0;
            userPlannedTasksData = await JSON.parse(JSON.stringify(userPlannedTasksData));
            if (userPlannedTasksData.length > 0) {
              userPlannedTasksData.forEach(plannedData => {
                actualHours += plannedData.actualHours;
              });
              task.actualHoursTotal = actualHours;
              const isTaskInprogress = userPlannedTasksData.find((t) => t.status === 'in-progress');
              const isTaskCompleted = userPlannedTasksData.find((t) => t.status === 'completed');
              if (isTaskInprogress !== undefined) {
                task.status = 'in-progress';
              } else if (isTaskCompleted !== undefined) {
                task.status = 'completed';
              } else {
                task.status = 'backlog';
              }
            }
            else {
              task.actualHoursTotal = actualHours;
              task.status = 'new';
            }
          });

        });
      }
      // console.log('geTaskForProjectsBasedGrouped', projectsLists);
      this.productsList = projectsLists;
      this.geTodoForProjectsBased();
      this.checkedLoginWeb();
    });
  }

  /**
   * * groupBy function is used to group the array based on keyName 
   * @Params array: need to pass the array
   * @Params Key: need to pass the key name 
   */
  groupBy = (array, key) => {
    // Return the end result
    return array.reduce((result, currentValue) => {
      // If an array already present for key, push it to the array. Else create an array and push the object
      (result[currentValue[key]] = result[currentValue[key]] || []).push(
        currentValue
      );
      // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
      return result;
    }, {}); // empty object is the initial value for result object
  }


  /**
   * * Navigate to the project backlogs page
   */
  projectBacklogs(projectData, projectName): void {
    this.router.navigate(['/scrumboard/board/sprint/' + projectData.Project.objectId + '/' + projectName]);
  }

  /**
   * get the update data from database (After Task saved)
   */
  taskSaved(data): void {
    this.geTaskForProjectsBased();
  }

  async getDoneList(event?) {
    let condition = [];
    condition = [
      { condition: 'equalTo', field: 'deleted', value: false },
      { condition: 'equalTo', field: 'completed', value: true },
      { condition: 'equalTo', field: 'status', value: 'completed' },
      { condition: 'include', value: 'owner' },
      { condition: 'include', value: 'owner.user' },
      { condition: 'include', value: 'department' },
      { condition: 'include', value: 'owner.user.profile' },
      { condition: 'descending', field: 'updatedAt' },
    ];
    if (this.empRole != 'Admin' && this.filterType != 'Created Task') {
      condition.push({ condition: 'containedIn', field: 'assigneesId', value: [this.profileId] });
    }
    const filter: any = event ? event.filters : '';
    if (!filter && filter != '') {
      if (this.filterCondition.length > 0) {
        condition.unshift(this.filterCondition[0]);
      }
      if (this.tagCondition.length > 0) {
        condition.unshift(this.tagCondition[0]);
      }
      const skip: number = event.first;
      this.doneCount = await this.getTotalRecordsCount(condition);
      this.lazyLoadDone(condition, skip, event.rows);
    } else {
      if (this.filterCondition.length > 0) {
        condition.unshift(this.filterCondition[0]);
      }
      if (this.tagCondition.length > 0) {
        condition.unshift(this.tagCondition[0]);
      }
      // tslint:disable-next-line:forin
      if (filter != '') {
        for (let key in filter) {
          let query = filter[key].value;
          key = key == 'bloodGroup' ? 'personalInfo.bloodGroup' : key;
          if (key == 'reportingTo' || key == 'owner' || key == 'assigneesId' || key == 'department' || key == 'personalInfo.bloodGroup') {
            condition.push({ condition: 'containedIn', field: key, value: filter[key].value });
          } else {
            let filterValue = filter[key].value;
            if (key != 'officialInfo.officialEmail') {
              filterValue = filter[key].value.replace(/\b\w/g, l => l.toUpperCase());
            }
            condition.push({ condition: 'contains', field: key, value: filterValue });
          }
        }
      }
      this.doneCount = await this.getTotalRecordsCount(condition);
      let first = (event ? event.first : 0);
      let rows = (event ? event.rows : 10);
      if (this.doneCount < first) {
        first = 0;
      }
      this.lazyLoadDone(condition, first, rows);
    }
  }

  async getInprogressList(event?) {
    let condition = [];
    condition = [
      { condition: 'equalTo', field: 'deleted', value: false },
      { condition: 'equalTo', field: 'completed', value: false },
      { condition: 'equalTo', field: 'status', value: 'inprogress' },
      { condition: 'include', value: 'owner' },
      { condition: 'include', value: 'owner.user' },
      { condition: 'include', value: 'department' },
      { condition: 'include', value: 'owner.user.profile' },
      { condition: 'descending', field: 'updatedAt' },
      { condition: 'equalTo', field: 'tenantId', value: this.tenantId },
      { condition: 'equalTo', field: 'isTodo', value: true }
    ];
    if (this.empRole != 'Admin' && this.filterType != 'Created Task') {
      condition.push({ condition: 'containedIn', field: 'assigneesId', value: [this.profileId] });
    }
    const filter: any = event ? event.filters : '';
    if (!filter && filter != '') {
      if (this.filterCondition.length > 0) {
        condition.unshift(this.filterCondition[0]);
      }
      if (this.tagCondition.length > 0) {
        condition.unshift(this.tagCondition[0]);
      }
      const skip: number = event.first;
      this.inprogressCount = await this.getTotalRecordsCount(condition);
      this.lazyLoadInprogress(condition, skip, event.rows);
    } else {
      if (this.filterCondition.length > 0) {
        condition.unshift(this.filterCondition[0]);
      }
      if (this.tagCondition.length > 0) {
        condition.unshift(this.tagCondition[0]);
      }
      // tslint:disable-next-line:forin
      if (filter != '') {
        for (let key in filter) {
          let query = filter[key].value;
          key = key == 'bloodGroup' ? 'personalInfo.bloodGroup' : key;
          if (key == 'reportingTo' || key == 'owner' || key == 'assigneesId' || key == 'department' || key == 'personalInfo.bloodGroup') {
            condition.push({ condition: 'containedIn', field: key, value: filter[key].value });
          } else {
            let filterValue = filter[key].value;
            if (key != 'officialInfo.officialEmail') {
              filterValue = filter[key].value.replace(/\b\w/g, l => l.toUpperCase());
            }
            condition.push({ condition: 'contains', field: key, value: filterValue });
          }
        }
      }
      this.inprogressCount = await this.getTotalRecordsCount(condition);
      let first = (event ? event.first : 0);
      let rows = (event ? event.rows : 10);
      if (this.inprogressCount < first) {
        first = 0;
      }
      this.lazyLoadInprogress(condition, first, rows);
    }
  }

  lazyLoadThingsToDo(condition, skip, limit) {
    this.spinner.show();
    condition.push({ condition: 'skip', value: skip }, { condition: 'limit', value: limit }, { condition: 'equalTo', field: 'tenantId', value: this.tenantId },
      { condition: 'equalTo', field: 'isTodo', value: true });
    this.queryInterface.executeQuery(this.parseService, 'Tasks', condition).then(async results => {
      this.thingsToDo = await this.getToDoList(results, skip);
      this.spinner.hide();
    });
  }

  lazyLoadDone(condition, skip, limit) {
    this.spinner.show();
    condition.push({ condition: 'skip', value: skip }, { condition: 'limit', value: limit }, { condition: 'equalTo', field: 'tenantId', value: this.tenantId },
      { condition: 'equalTo', field: 'isTodo', value: true });
    this.queryInterface.executeQuery(this.parseService, 'Tasks', condition).then(async results => {
      this.done = await this.getToDoList(results, skip);
      this.spinner.hide();
    });
  }

  lazyLoadInprogress(condition, skip, limit) {
    this.spinner.show();
    condition.push({ condition: 'skip', value: skip }, { condition: 'limit', value: limit }, { condition: 'equalTo', field: 'tenantId', value: this.tenantId },
      { condition: 'equalTo', field: 'isTodo', value: true });
    this.queryInterface.executeQuery(this.parseService, 'Tasks', condition).then(async results => {
      this.inprogressList = await this.getToDoList(results, skip);
      this.spinner.hide();
    });
  }

  getTotalRecordsCount(condition) {
    condition.push({ condition: 'equalTo', field: 'tenantId', value: this.tenantId });
    return this.queryInterface.getQueryCount(this.parseService, 'Tasks', condition);
  }

  get f() {
    return this.todoForm.controls;
  }
  async getBoardLists(): Promise<void> {
    const ProjectBoardListsClass = this.parseService.instance.Object.extend('ProjectBoardLists');
    const projectBoardListsQuery = new this.parseService.instance.Query(ProjectBoardListsClass);
    projectBoardListsQuery.include('project');
    projectBoardListsQuery.equalTo('project', {
      __type: 'Pointer',
      className: 'Project',
      objectId: this.projectId
    });
    projectBoardListsQuery.equalTo('name', 'Backlogs');
    await projectBoardListsQuery.find().then(results => {
      this.backlogBoardListId = results[0].id;
    });
  }

  async getBacklogsSprint(): Promise<void> {
    const Sprint = this.parseService.instance.Object.extend('Sprint');
    const sprintQuery = new this.parseService.instance.Query(Sprint);
    // query.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: this.projectId });
    sprintQuery.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: this.projectId });
    sprintQuery.equalTo('name', 'Backlogs');
    await sprintQuery.find().then(async (result) => {
      this.getBacklogsSprintId = await result[0].id;
    });
  }

  async saveTodo() {
    this.isSaved = true;
    const results = await this.queryInterface.executeQuery(this.parseService, 'Project',
      [{ condition: 'equalTo', field: 'tenantId', value: this.tenantId },
      { condition: 'equalTo', field: 'defaultProject', value: true }]);
    const result = await results[0];
    this.projectId = result.id;

    await this.getBoardLists();
    await this.getBacklogsSprint();

    await this._scrumboardService.getBoard(this.getBacklogsSprintId, 'inActive').then(async res => {

      const createrProfile = this.currentUser.get('profile');
      const createrImg = createrProfile.get('profileImageInfo').url;
      const createrName = createrProfile.get('username');
      const activities = [];
      const activity = {
        message: 'Created a Todo',
        createdBy: createrName,
        createdId: createrProfile.id,
        createdDate: new Date().toUTCString(),
        createrImgUrl: createrImg === undefined ? this.hardCodedValues.defaultProfileImg : createrImg
      };
      activities.push(activity);
      this.activityCenterService.createActivity(activities, this.hardCodedValues.sprint, this.getBacklogsSprintId);


    });
    // return;
    let datePipe = new DatePipe('en-US');
    this.submitted = true;
    if (this.todoForm.invalid) {
      this.toastr.warning('Please enter the required fields');
      return;
    }
    if (this.todoForm.valid) {
      let values = this.todoForm.value;
      let assignees = [];
      let assigneesId = [];
      for (const data of values.assignees) {
        assigneesId.push(data.code);
      }
      let userId = this.parseService.instance.User.current().id;
      let taskDetails = {
        title: values.title,
        notes: values.notes ? values.notes : '',
        startDate: new Date(values.startDate).toISOString(),
        dueDate: new Date(values.dueDate).toISOString(),
      };
      let taskClass = this.parseService.instance.Object.extend('Tasks');
      var taskDetail = new taskClass();
      taskDetail.set('owner', { __type: 'Pointer', className: '_User', objectId: userId });
      taskDetail.set('sprintId', {
        __type: 'Pointer',
        className: 'Sprint',
        objectId: this.getBacklogsSprintId
      });
      taskDetail.set('scrumboardList', {
        __type: 'Pointer',
        className: 'ProjectBoardLists',
        objectId: this.backlogBoardListId
      });
      taskDetail.set('title', values.title);
      taskDetail.set('startDate', new Date(values.startDate));
      if (values.dueDate) {
        taskDetail.set('dueDate', new Date(values.dueDate));
      }
      taskDetail.set('important', values.important);
      taskDetail.set('starred', values.starred);
      taskDetail.set('taskDetails', taskDetails);
      taskDetail.set('priority', values.priority);
      taskDetail.set('typeOfTask', []);
      taskDetail.set('taskType', [values.priority]);
      // taskDetail.set('estimatedHours', this.convertHourMinutesToSeconds(values.estimatedHours));
      taskDetail.set('estimatedHours', this.dateService.convertStringHrsToSeconds(values.estimatedHours));
      taskDetail.set('completedHours', 0);
      taskDetail.set('department', { __type: 'Pointer', className: 'Department', objectId: values.department });
      taskDetail.set('Project', { __type: 'Pointer', className: 'Project', objectId: this.projectId });
      taskDetail.set('tag', values.tag);
      taskDetail.set('userPlannedStatus', values.status);
      taskDetail.set('isActive', true);
      taskDetail.set('defaultTask', false);
      taskDetail.set('syncTime', 0);
      taskDetail.set('isAllocated', false);
      taskDetail.set('deleted', values.deleted);
      taskDetail.set('comments', values.comments);
      taskDetail.set('completed', false);
      taskDetail.set('todoNumber', this.generateRandomNumber(5));
      taskDetail.set('tenantId', this.tenantId);
      taskDetail.set('assigneesId', assigneesId);
      taskDetail.set('isTodo', true);
      let assigneesEmailId = [];
      assigneesId.forEach(element => {
        var queryProfile = new this.parseService.instance.Object('Profile');
        queryProfile.id = element;
        // var relation = taskDetail.relation('assignees');
        var relation = taskDetail.relation('assignee');
        relation.add(queryProfile);
        assignees.push({
          userName: queryProfile.get('firstName') + ' ' + queryProfile.get('lastName'),
          profileImage: queryProfile.get('profileImageInfo').url == undefined ? this.hardCodedValues.defaultProfileImg : queryProfile.get('profileImageInfo').url,
          toEmail: queryProfile.get('officialInfo').officialEmail ? queryProfile.get('officialInfo').officialEmail : ''
        });
        assigneesEmailId.push(queryProfile.get('officialInfo').officialEmail);

        if (this.profileId != element) {
          let sendSocket = {
            event_type: 'NEW_TODO_ASSIGNED',
            event_owner: {
              id: this.parseService.instance.User.current().get('profile').id,
              name: this.firstName + ' ' + this.lastName,
            },
            event_receiver: {
              id: element,
              name: queryProfile.get('firstName') + ' ' + queryProfile.get('lastName'),
            },
            message: 'You have been assigned to a todo',
            event_created_Date: new Date(),
            initiated_source: 'web',
            task: {
              title: values.title,
              assigneName: queryProfile.get('firstName') + ' ' + queryProfile.get('lastName'),
              profileImage: queryProfile.get('profileImageInfo').url,
              projectName: 'Todo'
            }
          }
          this._socket.sendSocketEvent('SOCKET_EMIT_EVENT', sendSocket);
        }
      });

      let comments = values.comments;

      let res = await taskDetail.save();
      this.todoId = res.id;
      if (!res.get('deleted')) {
        this.toastr.success('To do Created Successfully');
      }
      this.drawer.close();
      this.todoType = 'edit';
      this.getThingsTodo();
      let value = JSON.parse(JSON.stringify(res));
      let profile = await this.getProfileId(value.owner.objectId);
      this.submitted = false;

      const data = {
        title: value.title,
        priority: values.priority,
        // dueDate: datePipe.transform(dueDate, 'dd/MM/yyyy'),
        ownerName: profile.get('firstName') + ' ' + profile.get('lastName'),
        important: value.important,
        assignees: assignees,
        comments: comments
      };

      if (value.dueDate) {
        let dueDate = new Date(value.dueDate.iso);
        data['dueDate'] = datePipe.transform(dueDate, 'dd/MM/yyyy');
      }

      // this.regForm.resetForm();
      setTimeout(() => this.formGroupDirective.resetForm(), 200);

      this.dataService.add(this.configuration.todoAssigned, data).subscribe((data: any) => {
      });

      /**
       * get the update data from database (After todo saved)
       */
      this.geTaskForProjectsBased();
    }
    else {
      this.toastr.warning('Please enter the required fields');
    }

  }

  convertHourMinutesToSeconds(value) {
    var hms = value;   // your input string
    var a = hms.split(':'); // split it at the colons

    // minutes are worth 60 seconds. Hours are worth 60 minutes.
    var seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60;
    return seconds;
  }

  generateRandomNumber(n) {
    return Math.floor(Math.random() * (9 * Math.pow(10, n - 1))) + Math.pow(10, n - 1);
  }

  async getProfileId(userId) {
    let queryInstance = this.parseService.instance.Object.extend("User")
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo("objectId", userId);
    query.include('profile');
    let results = await query.find();
    return results[0];
  }

  editTask(selectedTask, projectName): void {
    this.viewProjectName = projectName;
    // this.todoListItemService.sendSelectedTask(selectedTask);
    const selectedProjectDetails = {
      projectName: selectedTask.Project.projectInfo.projectName,
      projectId: selectedTask.Project.objectId
    };
    this.todoListItemService.sendSelectedTask(selectedTask, selectedProjectDetails);
  }

  async editTodo(todoId, currentStatus) {
    this.todoId = todoId;
    this.todoType = 'edit';
    let queryInstance = this.parseService.instance.Object.extend('Tasks');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('objectId', this.todoId);
    query.include('owner');
    query.include('owner.user');
    query.include('owner.user.profile');
    query.include('department');
    let result = await query.find();
    let data = result[0];
    let assignees = [];
    for (const res of data.get('assigneesId')) {
      var queryProfile = new this.parseService.instance.Object('Profile');
      queryProfile.id = res;
      assignees.push({
        name: queryProfile.get('firstName') + ' ' + queryProfile.get('lastName'),
        code: res
      });
    }
    this.canEnableTodoEstimatedHrs = data.get('isAllocated');
    let completedHours = this.secondsToHms(data.get('completedHours'));
    this.todoForm.patchValue({
      title: data.get('title'),
      startDate: data.get('startDate'),
      dueDate: data.get('dueDate'),
      notes: data.get('taskDetails').notes,
      // estimatedHours: this.secondsToHms(data.get('estimatedHours')),
      estimatedHours: this.dateService.convertSecondsToHmString(data.get('estimatedHours')),
      completedHours: completedHours,
      department: data.get('department') ? data.get('department').id : '',
      priority: data.get('priority'),
      // status: data.get('userPlannedStatus'),
      status: currentStatus,
      starred: data.get('starred'),
      important: data.get('important'),
      completed: data.get('completed'),
      deleted: data.get('deleted'),
      tag: data.get('tag'),
      commentsText: '',
      assignees: assignees,
      comments: data.get('comments')
    });
    if (currentStatus === 'completed') {
      this.todoForm.disable();
    } else {
      this.todoForm.enable();
    }
    let image = '';
    let currentUserProfileImage = data.get('owner').get('profile').get('profileImageInfo');
    if (this.isEmpty(currentUserProfileImage)) {
      image = this.hardCodedValues.defaultProfileImg;
    } else {
      image = currentUserProfileImage.url
    }
    this.previousComments = JSON.parse(JSON.stringify(data.get('comments')));
    this.status = this.todoForm.value.status;
    this.organizerImage = image;
    this.organizerName = data.get('owner').get('profile').get('firstName') + ' ' + data.get('owner').get('profile').get('lastName');
    this.organizerEmail = data.get('owner').get('profile').get('email');
    this.todoNumber = data.get('todoNumber') ? data.get('todoNumber') : '';
  }

  async updateTodo(showSaveToastr) {
    let datePipe = new DatePipe('en-US');
    this.submitted = true;
    if (this.todoForm.invalid) {
      return;
    }
    if (this.todoForm.valid) {
      let values = this.todoForm.value;
      let newComments = values.comments;
      let queryInstance = this.parseService.instance.Object.extend('Tasks');
      let query = new this.parseService.instance.Query(queryInstance);
      query.equalTo('objectId', this.todoId);
      let result = await query.find();
      let taskDetails = {
        title: values.title,
        notes: values.notes ? values.notes : '',
        startDate: new Date(values.startDate).toISOString(),
      };
      if (values.dueDate) {
        taskDetails['dueDate'] = new Date(values.dueDate).toISOString();
      }
      let assigneesId = [];
      for (const data of values.assignees) {
        assigneesId.push(data.code);
      }
      let taskDetail = result[0];
      taskDetail.set('title', values.title);
      taskDetail.set('startDate', new Date(values.startDate));
      if (values.dueDate) {
        taskDetail.set('dueDate', new Date(values.dueDate));
      }
      taskDetail.set('priority', values.priority);
      taskDetail.set('department', { __type: 'Pointer', className: 'Department', objectId: values.department });
      // taskDetail.set('estimatedHours', this.convertHourMinutesToSeconds(values.estimatedHours));
      taskDetail.set('estimatedHours', this.dateService.convertStringHrsToSeconds(values.estimatedHours));
      taskDetail.set('important', values.important);
      taskDetail.set('starred', values.starred);
      taskDetail.set('taskDetails', taskDetails);
      taskDetail.set('tag', values.tag);
      taskDetail.set('status', values.status);
      taskDetail.set('completed', values.completed);
      taskDetail.set('deleted', values.deleted);
      taskDetail.set('comments', values.comments);
      taskDetail.set('assigneesId', assigneesId);
      taskDetail.set('updatedAt', new Date());

      let assignees = taskDetail.get('assignee');
      let oldAssignees = [];
      let newAssignees = assigneesId;
      await assignees.query().each(element => {
        oldAssignees.push(element.id);
        let queryProfile = new this.parseService.instance.Object('Profile');
        queryProfile.id = element.id;
        let relation = taskDetail.relation('assignee');
        relation.remove(queryProfile);
      });
      let assigneesEmailId = [];
      for (const element of assigneesId) {
        var queryProfile = new this.parseService.instance.Object('Profile');
        queryProfile.id = element;
        var relation = taskDetail.relation('assignee');
        relation.add(queryProfile);
        assigneesEmailId.push(queryProfile.get('officialInfo').officialEmail);
      }

      let todo = await taskDetail.save();
      if (showSaveToastr) {
        this.toastr.success('Saved Successfully');
      }
      this.drawer.close();
      this.submitted = false;
      this.getThingsTodo();
      if (values.completed == true || values.status == 'completed') {
        this.getDoneList();
        await this.updateUserPlannedTodo(this.todoId);
        newAssignees.forEach(async data => {
          let queryProfile = new this.parseService.instance.Object('Profile');
          queryProfile.id = data;

          let sendSocket = {
            event_type: 'TODO_COMPLETED ' + values.title,
            event_owner: {
              id: this.parseService.instance.User.current().get('profile').id,
              name: this.firstName + ' ' + this.lastName,
            },
            event_receiver: {
              id: data,
              name: queryProfile.get('firstName') + ' ' + queryProfile.get('lastName'),
            },
            message: this.firstName + ' ' + this.lastName + ' deleted a todo - ' + values.title,
            event_created_Date: new Date(),
            initiated_source: 'web',
            task: {
              assigneName: queryProfile.get('firstName') + ' ' + queryProfile.get('lastName'),
              profileImage: queryProfile.get('profileImageInfo').url,
              projectName: 'Todo'
            }
          }
          this._socket.sendSocketEvent('SOCKET_EMIT_EVENT', sendSocket);
        });
      }
      if (values.status == 'inprogress') {
        this.getInprogressList();
      }
      if (values.status == 'new') {
        this.getInprogressList();
      }
      if (values.deleted == true) {
        newAssignees.forEach(data => {
          var queryProfile = new this.parseService.instance.Object('Profile');
          queryProfile.id = data;

          let sendSocket = {
            event_type: 'TODO_DELETED ' + values.title,
            event_owner: {
              id: this.parseService.instance.User.current().get('profile').id,
              name: this.firstName + ' ' + this.lastName,
            },
            event_receiver: {
              id: data,
              name: queryProfile.get('firstName') + ' ' + queryProfile.get('lastName'),
            },
            message: this.firstName + ' ' + this.lastName + ' deleted a todo - ' + values.title,
            event_created_Date: new Date(),
            initiated_source: 'web',
            task: {
              assigneName: queryProfile.get('firstName') + ' ' + queryProfile.get('lastName'),
              profileImage: queryProfile.get('profileImageInfo').url,
              projectName: 'Todo'
            }
          }
          this._socket.sendSocketEvent('SOCKET_EMIT_EVENT', sendSocket);
        });

        this.deleteUserPlannedTodo(this.todoId);
      }

      if (this.previousComments.length < newComments.length) {
        let sendSocket = {
          event_type: 'TODO_COMMENTS',
          event_owner: {
            id: this.parseService.instance.User.current().get('profile').id,
            name: this.firstName + ' ' + this.lastName,
          },
          event_receiver: {
            id: todo.get('owner').id,
            name: todo.get('owner').get('firstName') + ' ' + todo.get('owner').get('lastName'),
          },
          message: this.firstName + ' ' + this.lastName + ' added a comments in todo - ' + values.title,
          event_created_Date: new Date(),
          initiated_source: 'web',
          task: {
            assigneName: queryProfile.get('firstName') + ' ' + queryProfile.get('lastName'),
            profileImage: queryProfile.get('profileImageInfo').url,
            projectName: 'Todo'
          }
        }
        this._socket.sendSocketEvent('SOCKET_EMIT_EVENT', sendSocket);

        let comments = newComments.filter(x => !this.previousComments.includes(x)); // New Added values
        let data = {
          organizerName: this.organizerName,
          toEmail: assigneesEmailId,
          title: values.title,
          startDate: datePipe.transform(new Date(values.startDate), 'dd/MM/yyyy'),
          dueDate: datePipe.transform(new Date(values.dueDate), 'dd/MM/yyyy'),
          priority: values.priority,
          status: values.status,
          comments: comments
        };

        this.dataService.add(this.configuration.todoComments, data).subscribe((data: any) => {
        });
      }

      var differenceInOldAssignees = oldAssignees.filter(x => !newAssignees.includes(x)); // Removed values
      var differenceInNewAssignees = newAssignees.filter(x => !oldAssignees.includes(x)); // New Added values

      differenceInNewAssignees.forEach(element => {
        var queryProfile = new this.parseService.instance.Object('Profile');
        queryProfile.id = element;

        let sendSocket = {
          event_type: 'NEW_TODO_ASSIGNED',
          event_owner: {
            id: this.parseService.instance.User.current().get('profile').id,
            name: this.firstName + ' ' + this.lastName,
          },
          event_receiver: {
            id: element,
            name: queryProfile.get('firstName') + ' ' + queryProfile.get('lastName'),
          },
          message: 'You have been assigned to a todo',
          event_created_Date: new Date(),
          initiated_source: 'web',
          task: {
            assigneName: queryProfile.get('firstName') + ' ' + queryProfile.get('lastName'),
            profileImage: queryProfile.get('profileImageInfo').url,
            projectName: 'Todo'
          }
        }
        this._socket.sendSocketEvent('SOCKET_EMIT_EVENT', sendSocket);
      });

      differenceInOldAssignees.forEach(element => {
        var queryProfile = new this.parseService.instance.Object('Profile');
        queryProfile.id = element;

        let sendSocket = {
          event_type: 'NEW_TODO_UNASSIGNED',
          event_owner: {
            id: this.parseService.instance.User.current().get('profile').id,
            name: this.firstName + ' ' + this.lastName,
          },
          event_receiver: {
            id: element,
            name: queryProfile.get('firstName') + ' ' + queryProfile.get('lastName'),
          },
          message: 'You have been unassigned from the todo',
          event_created_Date: new Date(),
          initiated_source: 'web',
          task: {
            assigneName: queryProfile.get('firstName') + ' ' + queryProfile.get('lastName'),
            profileImage: queryProfile.get('profileImageInfo').url,
            projectName: 'Todo'
          }
        }
        this._socket.sendSocketEvent('SOCKET_EMIT_EVENT', sendSocket);
      });

      // this.regForm.resetForm();
      setTimeout(() => this.formGroupDirective.resetForm(), 200);
    }
    else {
      this.toastr.warning('Please enter the required fields');
    }
  }

  async deleteUserPlannedTodo(todoId) {
    let userPlannedClass = this.parseService.instance.Object.extend('UserPlannedTasks');
    let deleteOldRecords = new this.parseService.instance.Query(userPlannedClass);
    deleteOldRecords.equalTo('todoId', { __type: 'Pointer', className: 'Todos', objectId: todoId });
    deleteOldRecords.limit(100);
    let queryResult = await deleteOldRecords.find();
    if (queryResult.length > 0) {
      this.parseService.instance.Object.destroyAll(queryResult);
    }
  }

  async updateUserPlannedTodo(todoId) {
    let userPlannedClass = this.parseService.instance.Object.extend('UserPlannedTasks');
    let updateRecords = new this.parseService.instance.Query(userPlannedClass);
    updateRecords.equalTo('todoId', { __type: 'Pointer', className: 'Todos', objectId: todoId });
    updateRecords.descending('createdAt');
    updateRecords.limit(100);
    let queryResult = await updateRecords.find();
    if (queryResult.length > 0) {
      let taskDetail = queryResult[0];
      taskDetail.set('status', 'completed');
      taskDetail.set('isCompleted', true);
      let res = await taskDetail.save();
    }
  }

  async taskStartStop(event, selectedTask): Promise<void> {
    if (await this.getInprogressTask(selectedTask.objectId) === true) {
      this.toastr.warning('Please complete the InProgress task');
      return;
    }

    this.selectedStatusName = event.value;
    const startTimeGet = localStorage.getItem('taskStartTime');
    if (startTimeGet !== null) {
      const endTime = Date.now();
      const actualTimeWorked = endTime - +startTimeGet;
      this.actualTimeForTask = this.secondsToHm(actualTimeWorked / 1000);
      // console.log('secondsToHm', this.secondsToHm(actualTimeWorked / 1000));
      // localStorage.removeItem('taskStartTime');
      this.actualHoursPopup(selectedTask);
    } else {
      const startTime = Date.now().toString();
      // localStorage.setItem('taskStartTime', startTime);
      // this.todoListItemService.updateTaskForHeader(selectedTask);
      await this.checkUserPlannedIsAvailable(selectedTask, event.value, startTime);
      // console.log('selectedTask', selectedTask);
      await this.getInprogressTask();
      this.geTaskForProjectsBased();

    }
  }

  async checkedLoginWeb(): Promise<any> {
    const userTimeSheet = this.parseService.instance.Object.extend('UserTimeSheet');
    const UserTimeSheetQuery = new this.parseService.instance.Query(userTimeSheet);
    const dateDifferent = this.dateService.startEndDateByDate(new Date());
    const currentProfileId = this.parseService.instance.User.current().get('profile').id;
    UserTimeSheetQuery.equalTo('tenantId', this.tenantId);
    UserTimeSheetQuery.equalTo('profileId', {
      __type: 'Pointer',
      className: 'Profile',
      objectId: currentProfileId
    });
    UserTimeSheetQuery.greaterThan('createdAt', dateDifferent[0]);
    UserTimeSheetQuery.lessThan('createdAt', dateDifferent[1]);
    const result = await UserTimeSheetQuery.find();
    if (result.length > 0) {
      this.isLoggedInWeb = true;
    } else {
      this.isLoggedInWeb = false;
    }
  }

  actualHoursPopup(selectedTask): void {
    this.selectedTask = selectedTask;
    this.dialog.open(this.actualTimeConfirm, {
      width: '300px',
      disableClose: true
    });
  }

  closePreviousTask(): void {
    this.dialog.open(this.previousInProgressTask, {
      width: '300px',
      disableClose: true
    });
  }

  async savePerviousInProgressTask(status): Promise<void> {

    /**
     * * check actual hours is valid format
     */
    if (this.checkActualHoursIsValid(this.actualTimeForTask) === false) {
      this.toastr.error('Please enter the valid hours (00:00)');
      return;
    }

    const currentProfileId = this.parseService.instance.User.current().get('profile').id;
    const UserPlannedTasksClass = this.parseService.instance.Object.extend('UserPlannedTasks');
    const userPlannedTask = new this.parseService.instance.Query(UserPlannedTasksClass);
    userPlannedTask.equalTo('tenantId', this.tenantId);
    userPlannedTask.equalTo('objectId', this.previousDayUserPlannedTasksId);
    userPlannedTask.equalTo('profileId', {
      __type: 'Pointer',
      className: 'Profile',
      objectId: currentProfileId
    });
    let userPlannedTaskResult = await userPlannedTask.find();
    userPlannedTaskResult = userPlannedTaskResult[0];
    if (userPlannedTaskResult) {
      const previousActualSeconds = userPlannedTaskResult.get('actualHours');
      const currentActualSeconds = this.dateService.convertStringHrsToSeconds(this.actualTimeForTask);
      userPlannedTaskResult.set('actualHours', previousActualSeconds + currentActualSeconds);
      userPlannedTaskResult.set('status', status);
      userPlannedTaskResult.set('webTaskStartTime', '');
      userPlannedTaskResult.save().then(async (results) => {
        const taskId = results.get('taskId');
        taskId.set('userPlannedStatus', status);
        await taskId.save();
        this.dialog.closeAll();
        this.toastr.success('Previous InProgress Task saved successfully');
        this.todoListItemService.updateTaskForHeader(false);
        await this.getInprogressTask();
        this.geTaskForProjectsBased();

      });
    }

  }

  async checkUserPlannedIsAvailable(selectedTask, statusName, startTime): Promise<void> {

    const isAvailable = await this.getCurrentUserPlannedTasks(selectedTask, startTime);
    if (isAvailable === undefined) {
      await this.createUserPlannedRecord(selectedTask, startTime);
    }
    this.todoListItemService.updateTaskForHeader(selectedTask);
  }

  async getInprogressTask(taskId?): Promise<any> {
    const currentProfileId = this.parseService.instance.User.current().get('profile').id;
    const UserPlannedClass = this.parseService.instance.Object.extend('UserPlannedTasks');
    const userPlannedTask = new this.parseService.instance.Query(UserPlannedClass);
    userPlannedTask.equalTo('tenantId', this.tenantId);
    // userPlannedTask.equalTo('taskId', { __type: 'Pointer', className: 'Tasks', objectId: this.selectedTask.objectId });
    userPlannedTask.equalTo('profileId', {
      __type: 'Pointer',
      className: 'Profile',
      objectId: currentProfileId
    });
    userPlannedTask.equalTo('status', 'in-progress');
    const dateDifferent = this.dateService.startEndDateByDate(new Date());
    // userPlannedTask.greaterThan('date', dateDifferent[0]);
    userPlannedTask.lessThan('date', dateDifferent[1]);
    const userPlannedTaskResult = await userPlannedTask.find();

    if (userPlannedTaskResult.length > 0) {
      // this.isTaskInprogress = false; 
      this.isTaskInprogress = true;
      localStorage.setItem('taskStartTime', userPlannedTaskResult[0].attributes.webTaskStartTime);

      /**
       * * Check task is running from yesterday (not a todays inProgress task)
       */
      let inProgressDate = userPlannedTaskResult[0].attributes.date.setHours(0, 0, 0, 0);
      inProgressDate = new Date(inProgressDate);
      let currentDate: any = new Date().setHours(0, 0, 0, 0);
      currentDate = new Date(currentDate);
      if (inProgressDate.toDateString() !== currentDate.toDateString()) {
        this.previousDayUserPlannedTasksId = userPlannedTaskResult[0].id;
        this.toastr.warning('Please Hold or Complete the old task to continue further processing');
        const endTime = Date.now();
        const startTimeGet = localStorage.getItem('taskStartTime');
        const actualTimeWorked = endTime - +startTimeGet;
        this.actualTimeForTask = this.secondsToHm(actualTimeWorked / 1000);
        this.todoListItemService.updateTaskForHeader(userPlannedTaskResult[0].attributes);
        this.closePreviousTask();
        return;
      }

      /**
       * * return false if selected task id and userPlanned inprogress task id are same
       */
      if (userPlannedTaskResult[0].attributes.taskId.id === taskId) {
        return false;
      }
      /**
       * * update the inprogress task to the header (toolbar component)
       */
      this.todoListItemService.updateTaskForHeader(userPlannedTaskResult[0].attributes);
      return true;
    } else {
      localStorage.removeItem('taskStartTime');
      this.isTaskInprogress = false;
      return false;
    }
  }

  /**
   * * check it valid actual hours
   * @param hours (string)
   */
  checkActualHoursIsValid(hours): boolean {
    const colon = hours.split(':');
    const actualHoursLength = hours.length;
    if (colon.length !== 2) {
      return false; // return false If invalid format
    }
    if (actualHoursLength !== 5) {
      return false;  // return false If invalid format
    }
    return true;  // return true If valid format
  }

  async close(): Promise<void> {
    this.dialog.closeAll();
    await this.getInprogressTask();
    this.geTaskForProjectsBased();
  }

  async getProjectBoardListId(projectId, boardNames): Promise<any> {
    const ProjectBoardList = this.parseService.instance.Object.extend('ProjectBoardList');
    const projectBoardListQuery = new this.parseService.instance.Query(ProjectBoardList);
    projectBoardListQuery.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: projectId });
    projectBoardListQuery.containedIn('name', [...boardNames]);
    let result = await projectBoardListQuery.find();
    result = JSON.parse(JSON.stringify(result));
    return result.length > 0 ? result : [];
  }

  async getCurrentUserPlannedTasks(selectedTask, startTime): Promise<any> {
    const currentProfileId = this.parseService.instance.User.current().get('profile').id;
    const UserPlannedTasksClass = this.parseService.instance.Object.extend('UserPlannedTasks');
    const userPlannedTasks = new this.parseService.instance.Query(UserPlannedTasksClass);
    userPlannedTasks.include('taskId');
    userPlannedTasks.equalTo('profileId', {
      __type: 'Pointer',
      className: 'Profile',
      objectId: currentProfileId
    });
    userPlannedTasks.equalTo('taskId', {
      __type: 'Pointer',
      className: 'Tasks',
      objectId: selectedTask.objectId
    });
    const dateDifferent = this.dateService.startEndDateByDate(new Date());
    userPlannedTasks.greaterThan('date', dateDifferent[0]);
    userPlannedTasks.lessThan('date', dateDifferent[1]);
    const results = await userPlannedTasks.find();
    if (results.length > 0) {
      results[0].set('webTaskStartTime', startTime);
      localStorage.setItem('taskStartTime', startTime);
      results[0].set('status', this.selectedStatusName);
      await results[0].save();
      const taskId = results[0].get('taskId');
      taskId.set('userPlannedStatus', this.selectedStatusName);
      taskId.save();
    }
    return results[0];
  }


  async saveActualHours(): Promise<void> {
    /**
    * * check actual hours is valid format
    */
    if (this.checkActualHoursIsValid(this.actualTimeForTask) === false) {
      this.toastr.error('Please enter the valid hours (00:00)');
      return;
    }

    const currentProfileId = this.parseService.instance.User.current().get('profile').id;
    const UserPlannedClass = this.parseService.instance.Object.extend('UserPlannedTasks');
    const userPlannedTask = new this.parseService.instance.Query(UserPlannedClass);
    userPlannedTask.equalTo('tenantId', this.tenantId);
    userPlannedTask.equalTo('taskId', { __type: 'Pointer', className: 'Tasks', objectId: this.selectedTask.objectId });
    userPlannedTask.equalTo('profileId', {
      __type: 'Pointer',
      className: 'Profile',
      objectId: currentProfileId
    });
    const dateDifferent = this.dateService.startEndDateByDate(new Date());
    userPlannedTask.greaterThan('date', dateDifferent[0]);
    userPlannedTask.lessThan('date', dateDifferent[1]);
    let userPlannedTaskResult = await userPlannedTask.find();
    userPlannedTaskResult = userPlannedTaskResult[0];
    const previousActualSeconds = userPlannedTaskResult.get('actualHours');
    const currentActualSeconds = this.dateService.convertStringHrsToSeconds(this.actualTimeForTask);
    userPlannedTaskResult.set('actualHours', previousActualSeconds + currentActualSeconds);
    userPlannedTaskResult.set('status', this.selectedStatusName);
    userPlannedTaskResult.set('webTaskStartTime', '');
    userPlannedTaskResult.save().then(
      async (results) => {
        const taskId = results.get('taskId');
        taskId.set('userPlannedStatus', this.selectedStatusName);
        if (this.selectedStatusName === 'completed') {
          taskId.set('completedHours', this.selectedTask.actualHoursTotal + currentActualSeconds);
        }
        await taskId.save();
        this.dialog.closeAll();
        this.toastr.success('Task saved successfully');
        this.todoListItemService.updateTaskForHeader(false);
        await this.getInprogressTask();
        this.geTaskForProjectsBased();
      }
    );

  }

  async createUserPlannedRecord(selectedTask, startTime): Promise<void> {

    const currentProfileId = this.parseService.instance.User.current().get('profile').id;
    const currentUserId = this.parseService.instance.User.current().id;
    const date_str = new Date();
    const date = new Date(date_str);
    const day = date.toLocaleDateString('default', { weekday: 'long' });
    const ProjectMembers = this.parseService.instance.Object.extend('ProjectMembers');
    const projectMembers = new this.parseService.instance.Query(ProjectMembers);
    projectMembers.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: selectedTask.Project.objectId });
    projectMembers.equalTo('user', { __type: 'Pointer', className: '_User', objectId: currentUserId });
    projectMembers.equalTo('tenantId', this.tenantId);
    const role = await projectMembers.find();
    const roleName = role[0].get('role');
    const UserPlannedClass = this.parseService.instance.Object.extend('UserPlannedTasks');
    const userPlannedTask = new UserPlannedClass();
    userPlannedTask.set('estimatedHours', selectedTask.estimatedHours);
    if (selectedTask.isTodo === false) {
      userPlannedTask.set('taskId', { __type: 'Pointer', className: 'Tasks', objectId: selectedTask.objectId });
      userPlannedTask.set('taskType', 'Project');
    } else {
      userPlannedTask.set('taskId', { __type: 'Pointer', className: 'Tasks', objectId: selectedTask.objectId });
      userPlannedTask.set('taskType', 'Todos');
    }
    userPlannedTask.set('isCompleted', false);
    userPlannedTask.set('actualHours', 0);
    userPlannedTask.set('profileId', { __type: 'Pointer', className: 'Profile', objectId: currentProfileId });
    userPlannedTask.set('priority', selectedTask.priority);
    userPlannedTask.set('selectedRole', roleName);
    userPlannedTask.set('tenantId', this.tenantId);
    userPlannedTask.set('isWorkStarted', false);
    userPlannedTask.set('isCloned', false);
    // userPlannedTask.set('status', 'in-progress');
    userPlannedTask.set('status', this.selectedStatusName);
    userPlannedTask.set('project', { __type: 'Pointer', className: 'Project', objectId: selectedTask.Project.objectId });
    userPlannedTask.set('day', day);
    userPlannedTask.set('date', new Date());
    userPlannedTask.set('webTaskStartTime', startTime);
    const result = await userPlannedTask.save();
    const Task = this.parseService.instance.Object.extend('Tasks');
    const taskQuery = new this.parseService.instance.Query(Task);
    taskQuery.equalTo('objectId', selectedTask.objectId);
    let taskResult = await taskQuery.find();
    taskResult = taskResult[0];
    taskResult.set('userPlannedStatus', this.selectedStatusName);
    taskResult.set('isAllocated', true);
    await taskResult.save();
    localStorage.setItem('taskStartTime', startTime);
    // in-progress, backlog, completed, in-complete
  }

  async getDesktopStatus(): Promise<void> {
    const startEndDateByDate = this.dateService.startEndDateByDate(new Date());
    const UserTimeSheet = this.parseService.instance.Object.extend('UserTimeSheet');
    const userTimeSheetQuery = new this.parseService.instance.Query(UserTimeSheet);
    userTimeSheetQuery.greaterThan('createdAt', startEndDateByDate[0]);
    userTimeSheetQuery.lessThan('createdAt', startEndDateByDate[1]);
    userTimeSheetQuery.equalTo('profileId', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
    userTimeSheetQuery.find().then((userTimeSheet) => {
      const userTimeSheetData = userTimeSheet.length > 0 ? userTimeSheet[0].get('currentStatus') : undefined;
      const message = !userTimeSheetData ? 'Not yet Login' : userTimeSheetData === 'work' ? 'Online' : userTimeSheetData === 'Idle' ? 'idle' : 'Offline';
      this.desktopLoginStatus = !userTimeSheetData ? 'NTL' : userTimeSheetData === 'work' ? 'Online' : userTimeSheetData === 'idle' ? 'idle' : 'offline';
    });
  }

  async isWebDesktopUsing(profileId: string): Promise<any> {
    const ProfileClass = this.parseService.instance.Object.extend('Profile');
    const profileQuery = new this.parseService.instance.Query(ProfileClass);
    profileQuery.equalTo('objectId', profileId);
    let result = await profileQuery.find();
    result = result[0];
    return result.get('isWebDesktop');
  }

  desktopLoginStatusToaster(): void {
    this.toastr.info('You are using the desktop app');
  }

  webLoginToaster(): void {
    if (this.isWebDesktop) {
      this.toastr.info('Please start the Web App to work on the task');
    }
  }

  changeBoard(taskId, oldBoardId, newBoardId): void {
    this._scrumboardService.scrumboardListChange(taskId, oldBoardId, newBoardId);
  }

  /**
   * Toggle star
   *
   * @param event
   */
  toggleStar(event): void {
    event.stopPropagation();
    this.starred = !this.starred;
    this.todoForm.patchValue({
      starred: this.starred,
    });
  }

  /**
   * Toggle important
   *
   * @param event
   */
  toggleImportant(event): void {
    event.stopPropagation();
    this.important = !this.important;
    this.todoForm.patchValue({
      important: this.important,
    });
  }

  /**
   * Toggle Completed
   *
   * @param event
   */
  async toggleCompleted(event): Promise<void> {
    event.stopPropagation();
    this.completed = !this.completed;
    if (this.completed == true) {
      this.todoForm.patchValue({
        completed: this.completed,
        status: 'completed'
      });
    }
    if (this.completed == false) {
      this.todoForm.patchValue({
        completed: this.completed,
        status: this.status
      });
    }
  }

  statusChange(event) {
    if (event == 'completed') {
      this.todoForm.patchValue({
        completed: true,
      });
    }
    else {
      this.todoForm.patchValue({
        completed: false,
      });
    }
  }

  /**
   * Toggle Deleted
   *
   * @param event
   */
  toggleDeleted(event): void {
    event.stopPropagation();
    this.deleted = !this.todoForm.value.deleted;
    this.todoForm.patchValue({
      deleted: this.deleted,
    });

    this.updateTodo(false);
    this.toastr.success('To Do deleted Successfully');
  }

  /**
 * Toggle tag on todo
 *
 * @param tagId
 */
  toggleTagOnTodo(tagTitle): void {
    this.todoForm.patchValue({
      tag: tagTitle,
    });
  }


  hasTag(tagId): any {

  }

  filterTodo(type) {
    if (type == 'all') {
      this.filterCondition = [];
      this.filterType = '';
    }
    if (type == 'Starred') {
      this.filterCondition = [];
      this.filterCondition.push({ condition: 'equalTo', field: 'starred', value: true });
    }
    if (type == 'Important') {
      this.filterCondition = [];
      this.filterCondition.push({ condition: 'equalTo', field: 'important', value: true });
    }
    if (type == 'Assigned Task') {
      this.filterCondition = [];
      this.filterCondition.push({ condition: 'containedIn', field: 'assigneesId', value: [this.profileId] });
    }
    if (type == 'Created Task') {
      this.filterCondition = [];
      this.filterCondition.push({ condition: 'equalTo', field: 'owner', value: this.parseService.instance.User.current() });
    }
    if (type == 'Expired Task') {
      this.filterCondition = [];
      let dateDifferent = this.dateService.startEndDateByDate(new Date());
      this.filterCondition.push({ condition: 'lessThan', field: 'dueDate', value: dateDifferent[1] });
    }
    this.getThingsTodo();
    this.getDoneList();
    this.getInprogressList();
  }

  tagFilter(type) {
    if (type == 'all') {
      this.tagCondition = [];
      this.tagType = '';
    }
    if (type == 'Proposal' || type == 'Sales' || type == 'Documentation' || type == 'Hiring' || type == 'Project Management') {
      this.tagCondition = [];
      this.tagCondition.push({ condition: 'equalTo', field: 'tag', value: type });
    }
    this.getThingsTodo();
    this.getDoneList();
    this.getInprogressList();
  }

  clearFilter() {
    this.filterCondition = [];
    this.filterType = '';
    this.tagCondition = [];
    this.tagType = '';
    this.getThingsTodo();
    this.getDoneList();
    this.getInprogressList();

    // Clearing primeng table filters
    this.todoSearchUser = '';
    this.todoSelectReporting = '';
    this.todoSelectAssignee = '';
    this.todoSelectDepartment = '';
    this.todoSelectedStatus = '';
    this.inprogressSearchUser = '';
    this.inprogressSelectReporting = '';
    this.inprogressSelectAssignee = '';
    this.inprogressSelectDepartment = '';
    this.doneSearchUser = '';
    this.doneSelectReporting = '';
    this.doneSelectAssignee = '';
    this.doneSelectDepartment = '';
    this.todoTable.reset();
    this.inprogressTable.reset();
    this.doneTable.reset();
  }

  closeDrawer() {
    this.drawer.close();
    // this.regForm.resetForm();
    // setTimeout(() => this.formGroupDirective.resetForm(), 200);
  }

  changeDate(event) {

  }

  async onAssigneesChange(event) {
    if (event.value.length > 0) {
      let queryInstance = this.parseService.instance.Object.extend('Profile');
      let query = new this.parseService.instance.Query(queryInstance);
      query.equalTo('objectId', event.itemValue.code);
      query.include('role');
      query.include('department');
      let data = await query.find();
      if (data.length > 0) {
        let res = data[0];
        let dept = res.get('department') ? res.get('department').id : '';
        this.todoForm.patchValue({
          department: dept
        });
      }
    }
    else {
      this.todoForm.patchValue({
        department: ''
      });
    }
  }

  /*
  ** ==========================================================
  ** Getting Department Details
  ** ==========================================================
  */
  async getDepartment() {
    await this.getReportingToService.getDepartment().then(res => {
      this.deptOptions = res;
    });
  }

  /*
** ==========================================================
** Getting Reporting To Details
** ==========================================================
*/
  async getOwner() {
    let reportingToDD = [];
    let reportingList = [];
    let queryInstance = this.parseService.instance.Object.extend('_Role');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('reportingTo', true);
    query.equalTo('isActive', true);
    let resutls = await query.find();
    for (const element of resutls) {
      let queryInstance = this.parseService.instance.Object.extend('Profile');
      let query = new this.parseService.instance.Query(queryInstance);
      query.equalTo('isActive', true);
      query.equalTo('tenantId', this.tenantId);
      query.equalTo('role', { __type: 'Pointer', className: '_Role', objectId: element.id });
      let data = await query.find();
      for (const innerelement of data) {
        let queryInstance = this.parseService.instance.Object.extend('User');
        let query = new this.parseService.instance.Query(queryInstance);
        query.equalTo('tenantId', this.tenantId);
        query.equalTo('profile', { __type: 'Pointer', className: 'Profile', objectId: innerelement.id });
        let userdata = await query.find();
        let reporteeId = userdata.length > 0 ? userdata[0].id : '';
        let reportee = innerelement.get('firstName') + ' ' + innerelement.get('lastName');
        reportingToDD.push({ id: reporteeId, name: reportee });
        let reporting = reportingToDD;
        for (let i = 0; i < reporting.length; i++) {
          reportingList.push(reporting[i].name);
        }
        let result = this.uniqBy(reportingToDD, JSON.stringify);
        reportingToDD = result.sort((a, b) => a.name.localeCompare(b.name));
        this.reportingToOptions1 = this.bindDropDown(reportingToDD);
      }
    }
  }

  uniqBy(a, key) {
    var index = [];
    return a.filter(function (item) {
      var k = key(item);
      return index.indexOf(k) >= 0 ? false : index.push(k);
    });
  }

  bindDropDown(array: any[]): any[] {
    const dropDownItem = [];
    array.forEach(a => {
      dropDownItem.push({ label: a.name, value: a.id });
    });
    return dropDownItem;
  }

  async getLabels() {
    this.labelList = [];
    let queryInstance = this.parseService.instance.Object.extend('DataSettings');
    let query = new this.parseService.instance.Query(queryInstance);
    await query.find().then(results => {
      let result = results[0];
      this.labelList = result.get('taskType');
      this.statusList = result.get('todoStatusList');
    });
  }

  async getAssignees() {
    const resutls = [];
    let projectId;
    this.projects.forEach(element => {
      if (element.isDefaultProject) {
        projectId = element.id;
      }
    });
    const ProjectMembers = this.parseService.instance.Object.extend('ProjectMembers');
    const projectMembers = new this.parseService.instance.Query(ProjectMembers);
    projectMembers.equalTo('tenantId', this.tenantId);
    projectMembers.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: projectId });
    projectMembers.include('user');
    projectMembers.equalTo('isActive', true);
    projectMembers.equalTo('status', 'Assigned');
    projectMembers.include('user.profile');
    projectMembers.ascending('username');
    projectMembers.limit(10000);
    await projectMembers.find().then((members) => {
      members.forEach((member) => {
        resutls.push(member.get('user').get('profile'));
      });
    });

    if (this.reportingToDD.length > 0 || this.reportingList.length > 0) {
      this.reportingToDD = [];
      this.reportingList = [];
    }
    this.unassignedUserIds = [];
    this.unassignedProfileIds = [];
    let profileIds = [];

    for (const element of resutls) {
      let id = element.id;
      let reportee = element.get('firstName') + ' ' + element.get('lastName');
      let image = element.get('profileImageInfo') == undefined ? this.hardCodedValues.defaultProfileImg : element.get('profileImageInfo').url;
      let isActive = element.get("isActive");
      if (isActive == true) {
        this.reportingToDD.push({ id: id, name: reportee, image: image });
        let reporting = this.reportingToDD;
        for (let i = 0; i < reporting.length; i++) {
          this.reportingList.push(reporting[i].name);
        }
        profileIds.push(id);
      }
      let result = this.uniqBy(this.reportingToDD, JSON.stringify);
      this.reportingToDD = result.sort((a, b) => a.name.localeCompare(b.name));
      this.reportingToOptions = this.bindDropAssigneeDropDown(this.reportingToDD);
      this.reportingToOptions2 = this.bindDropDown(this.reportingToDD);
    }
    // });
    this.ownerOptions = [];
    let userClass = this.parseService.instance.Object.extend('_User');
    let userQuery = new this.parseService.instance.Query(userClass);
    userQuery.include('profile');
    userQuery.equalTo('tenantId', this.tenantId);
    userQuery.containedIn('profile', profileIds);
    userQuery.limit(100000);
    userQuery.ascending('username');
    let userResults = await userQuery.find();
    for (const res of userResults) {
      this.ownerOptions.push({ label: res.get('username'), value: res.id });
    }
  }

  secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = (h <= 9 ? '0' : '') + h;
    var mDisplay = (m <= 9 ? '0' : '') + m;
    var sDisplay = (s <= 9 ? '0' : '') + s;
    return hDisplay + ':' + mDisplay + ':' + sDisplay;
  }
  secondsToHm(d): string {
    d = Number(d);
    let h = Math.floor(d / 3600);
    let m = Math.floor((d % 3600) / 60);
    let s = Math.floor((d % 3600) % 60);

    let hDisplay = (h <= 9 ? '0' : '') + h;
    let mDisplay = (m <= 9 ? '0' : '') + m;
    return hDisplay + ':' + mDisplay;
  }

  bindDropAssigneeDropDown(array: any[]): any[] {
    const dropDownItem = [];
    array.forEach(a => {
      dropDownItem.push({ name: a.name, code: a.id });
    });
    return dropDownItem;
  }

  ngAfterViewInit(): void {
    let rteObj: RichTextEditorComponent = this.rteObj;
    if (rteObj != undefined) {
      setTimeout(() => { this.textArea = rteObj.contentModule.getEditPanel() as HTMLElement; }, 600);
    }
  }

  public mirrorConversion(e?: any): void {
    let id: string = this.rteObj.getID() + 'mirror-view';
    let mirrorView: HTMLElement = this.rteObj.element.querySelector('#' + id) as HTMLElement;
    let charCount: HTMLElement = this.rteObj.element.querySelector('.e-rte-character-count') as HTMLElement;
    if (e.targetItem === 'Preview') {
      this.textArea.style.display = 'block';
      mirrorView.style.display = 'none';
      this.textArea.innerHTML = this.myCodeMirror.getValue();
      charCount.style.display = 'block';
    } else {
      if (!mirrorView) {
        mirrorView = createElement('div', { className: 'e-content' });
        mirrorView.id = id;
        this.textArea.parentNode.appendChild(mirrorView);
      } else {
        mirrorView.innerHTML = '';
      }
      this.textArea.style.display = 'none';
      mirrorView.style.display = 'block';
      this.renderCodeMirror(mirrorView, this.rteObj.value);
      charCount.style.display = 'none';
    }
  }

  public renderCodeMirror(mirrorView: HTMLElement, content: string): void {
    this.myCodeMirror = CodeMirror(mirrorView, {
      value: content,
      lineNumbers: true,
      mode: 'text/html',
      lineWrapping: true,
    });
  }

  public actionCompleteHandler(e: any): void {
    if (e.targetItem && (e.targetItem === 'SourceCode' || e.targetItem === 'Preview')) {
      (this.rteObj.sourceCodeModule.getPanel() as HTMLTextAreaElement).style.display = 'none';
      this.mirrorConversion(e);
    }
    else {
      setTimeout(() => { this.rteObj.toolbarModule.refreshToolbarOverflow(); }, 400);
    }
  }

  handleRichTextEditor() {
    // console.log('event', this.rteObj);
  }

  /**
 * * Get project list that are assigned to the user
 */
  async getProjects(): Promise<void> {
    const userId = this.parseService.instance.User.current().id;
    const ProjectMembers = this.parseService.instance.Object.extend('ProjectMembers');
    const projectMembers = new this.parseService.instance.Query(ProjectMembers);
    projectMembers.equalTo('user', { __type: 'Pointer', className: '_User', objectId: userId });
    projectMembers.include('project');
    projectMembers.equalTo('status', 'Assigned');
    const projectListData = await projectMembers.find();
    this.projects = [];
    for (const project of projectListData) {
      this.projects.push({
        id: project.get('project').id,
        projectName: project.get('project').get('projectInfo').projectName,
        isDefaultProject: project.get('project').get('defaultProject')
      });
    }
    this.projects.forEach(element => {
      if (element.isDefaultProject) {
        this.viewProjectName = element.projectName;
      }
    });
  }

  // async getProjectss(): Promise<void> {
  //   this.projects = [];
  //   const Project = this.parseService.instance.Object.extend('Project');
  //   const projectQuery = new this.parseService.instance.Query(Project);
  //   projectQuery.equalTo('tenantId', this.tenantId);
  //   projectQuery.limit(100000);
  //   const projects = await projectQuery.find();
  //   projects.forEach(project => {
  //     const data = {
  //       id: project.id,
  //       projectName: project.get('projectInfo').projectName,
  //       isDefaultProject: project.get('defaultProject')
  //     };
  //     this.projects.push(data);
  //   });
  //   this.projects.forEach(element => {
  //     if (element.isDefaultProject) {
  //       this.viewProjectName = element.projectName;
  //     }
  //   });
  //   // console.log('projects', this.projects);
  // }

  checkIsDefaultProject(selectedProject) {
    // console.log('selectedProject', selectedProject);
    this.isDefaultProject = selectedProject.isDefaultProject ? true : false;
    this.selectedProjectName = selectedProject.projectName;
    this.selectedProjectId = selectedProject.id;
    const data = {
      projectId: this.selectedProjectId,
      changedProjectName: this.selectedProjectName
    };
    this.todoListItemService.project(data);
  }

  async editCardDialog(cardId): Promise<void> {
    this.dialogRef = this.dialog.open(ScrumboardCardDialogComponent, {
      panelClass: 'scrumboard-card-dialog',
      width: '1200px',
      data: {
        cardId: cardId,
        listId: 123,
        activeStatus: 'New'
      }
    });
    this.dialogRef.afterClosed().subscribe(async response => {
      // await this.getBacklogTasks().then(async res => {
      //   this.spinner.show();
      //   await this._scrumboardService.getBoard(this.backlogBoardId, 'inActive');
      //   this.spinner.hide();
      // });
    });
  }

  keyPress(event: any) {
    const pattern = /[1-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  ngOnDestroy(): void {
    clearInterval(this.TaskSyncInterval);
  }

  async getTenantDepartment(): Promise<void> {
    this.tenantDepartment = await this.getReportingToService.getTenantDepartment(this.tenantId);
  }

  chooseTaskType(event) {
    if (event.value == 'Custom...') {
      this.dialog.open(this.customTask, {
        width: '500px',
        disableClose: false
      });
    }
  }

  saveTodoInfo() {
    this.drawer.close();
    // if (this.scheduleType === 'Does not repeat') {
    //   this.saveTodo();
    // }
    // else {
    this.recurrence();
    // }
  }

  async recurrence() {
    this.spinner.show();

    if (this.todoForm.invalid) {
      this.spinner.hide();
      return this.toastr.warning('Please enter the required fields!!')
    }

    this.isSaved = true;
    const results = await this.queryInterface.executeQuery(this.parseService, 'Project',
      [{ condition: 'equalTo', field: 'tenantId', value: this.tenantId },
      { condition: 'equalTo', field: 'defaultProject', value: true }]);
    const result = await results[0];
    this.projectId = result.id;

    await this.getBoardLists();
    await this.getBacklogsSprint();

    await this._scrumboardService.getBoard(this.getBacklogsSprintId, 'inActive').then(async res => {
      const createrProfile = this.currentUser.get('profile');
      const createrImg = createrProfile.get('profileImageInfo').url;
      const createrName = createrProfile.get('username');
      const activities = [];
      const activity = {
        message: 'Created a Todo',
        createdBy: createrName,
        createdId: createrProfile.id,
        createdDate: new Date().toUTCString(),
        createrImgUrl: createrImg === undefined ? this.hardCodedValues.defaultProfileImg : createrImg
      };
      activities.push(activity);
      this.activityCenterService.createActivity(activities, this.hardCodedValues.sprint, this.getBacklogsSprintId);

    });

    let values = this.todoForm.value;
    let assigneesId = [];
    for (const data of values.assignees) {
      assigneesId.push(data.code);
    }
    let userId = this.parseService.instance.User.current().id;
    let taskDetails = {
      title: values.title,
      notes: values.notes ? values.notes : '',
      startDate: new Date(values.startDate).toISOString(),
      dueDate: new Date(values.dueDate).toISOString(),
    };

    let payload: any = {
      startDate: new Date(values.startDate),
      endDate: new Date(values.dueDate),
      dueDate: new Date(values.dueDate),
      title: values.title,
      recursiveKey: this.scheduleType,
      isRecursive: false,
      isDeleted: false,
      Project: this.projectId,
      taskType: [values.priority],
      owner: userId,
      sprintId: this.getBacklogsSprintId,
      scrumboardList: this.backlogBoardListId,
      important: values.important,
      starred: values.starred,
      taskDetails: taskDetails,
      priority: values.priority,
      typeOfTask: [],
      estimatedHours: this.dateService.convertStringHrsToSeconds(values.estimatedHours),
      completedHours: 0,
      department: values.department,
      tag: values.tag,
      userPlannedStatus: values.status,
      isActive: true,
      defaultTask: false,
      syncTime: 0,
      isAllocated: false,
      deleted: values.deleted,
      comments: values.comments,
      completed: false,
      todoNumber: this.generateRandomNumber(5),
      tenantId: this.tenantId,
      assigneesId: assigneesId,
      isTodo: true,
    }
    let service = `${this.configuration.createRecursive}?taskType=${this.scheduleType == 'Daily' ? 'daily' : this.scheduleType == `Weekly on ${this.currentDay}` ? 'weeklyOnSelected' :
      this.scheduleType == `Monthly on the third ${this.currentDay}` ? 'monthlyOnSelectedWeekday' : this.scheduleType == 'Every weekday (Monday to Friday)' ? 'weekdays' :
        this.scheduleType == 'Custom...' ? `custom${this.customDay}OnSelected` : this.scheduleType == 'Does not repeat' ? 'onlyThen' : ''}`;

    if (this.scheduleType == `Weekly on ${this.currentDay}`) { payload.repeatOn = [new Date().getDay()]; payload.weekCount = 1 }

    this.dataService.add(service, payload).subscribe((data: any) => {
      this.spinner.hide();
      this.toastr.success('Task created successfully');
    }, error => {
      this.spinner.hide();
      this.toastr.warning('Unable to created task');
      console.log('error', error);
    });
    this.scheduleType = 'Does not repeat';
    this.dialog.closeAll();
  }

  cancel() {
    this.scheduleType = 'Does not repeat';
    this.dialog.closeAll();
  }

  taskCalendar() {
    this.router.navigate(['calendar', { isTaskCalendar: true }])
  }
}
